import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { SwitcherComponent } from '../../shared/components/switcher/switcher.component';
import { DeliveryType } from '../../api/v1/models/delivery-type';
import { SessionRepository } from '../../shared/repositories/session.repository';
import { combineLatest, first, Observable, shareReplay, tap } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AddressDto } from '../../api/v1/models/address-dto';
import { OrderDeliveryModalService } from './order-delivery-modal.service';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { map } from 'rxjs/operators';
import {
  AddressSelectorComponent
} from 'src/app/layout/fresh/components/order-form/step-address/address-selector.component';
import { FormSaveStrategy, } from '../../layout/common/strategy/form-save-strategy/form-save-strategy.abstract';
import { ConfirmFormStrategy, } from '../../layout/common/strategy/form-save-strategy/confirm-form-strategy.service';

@Component({
  selector: 'app-order-delivery-modal',
  standalone: true,
  templateUrl: './order-delivery-modal.component.html',
  styleUrls: ['./order-delivery-modal.component.scss'],
  providers: [
    {provide: FormSaveStrategy, useClass: ConfirmFormStrategy},
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalComponent,
    SwitcherComponent,
    AddressSelectorComponent,
  ],
})
export class OrderDeliveryModalComponent implements OnInit {
  constructor(
    private sessionRepository: SessionRepository,
    private orderDeliveryModal: OrderDeliveryModalService,
    private configRepository: ConfigRepository,
    private formSaveStrategy: FormSaveStrategy,
  ){}

  isShowModal: boolean = false;

  addressControl: FormControl<AddressDto | null> = new FormControl<AddressDto | null>(null);
  switchControl: FormControl<DeliveryType | null> = new FormControl<DeliveryType | null>(null)

  deliveryTypes = DeliveryType;

  selectedDeliveryType$: Observable<DeliveryType | null> = this.sessionRepository.selectedDeliveryType$.pipe(
    tap(deliveryType => {
      this.switchControl.setValue(deliveryType)
    }),
    shareReplay({ refCount: false, bufferSize: 1 }),
  );

  deliveryModalTitle$: Observable<string> = this.selectedDeliveryType$.pipe(
    map(selectedDeliveryType => {
      if(selectedDeliveryType === DeliveryType.Delivery){
        return $localize`:@@DeliveryModalTitleDelivery:Enter delivery address`;
      }

      return $localize`:@@DeliveryModalTitlePickup:Select a restaurant`;
    })
  )

  deliveryAddress$: Observable<AddressDto | null> = this.sessionRepository.deliveryAddress$.pipe(
    first(),
    tap(address => {
      if(!address){return}
      this.addressControl.patchValue(address, {emitEvent: false})
    })
  )

  settings$: Observable<{isProvidingCollection: boolean, isProvidingDelivery: boolean}> = combineLatest([
    this.configRepository.isProvidingCollection$,
    this.configRepository.isProvidingDelivery$,
  ]).pipe(
    map(([isProvidingCollection, isProvidingDelivery]) => {
      return {isProvidingCollection, isProvidingDelivery}
    })
  )

  ngOnInit () {
    this.addressControl.valueChanges.subscribe((value) => {
      if(!this.isShowModal){return}
      this.sessionRepository.setDeliveryAddress(this.addressControl.getRawValue())
    });
  }

  onChangeOrderType(type: DeliveryType): void {
    this.sessionRepository.setDeliveryType(type);
  }

  onClose () {
    this.orderDeliveryModal.setOrderTypeModalState(false);
  }

  onConfirmPickup () {
    if (this.formSaveStrategy instanceof ConfirmFormStrategy) {
      this.formSaveStrategy.confirmSaveOutlet();
    }
    this.onClose();
  }

  onConfirmDeliveryAddress () {
    if (this.formSaveStrategy instanceof ConfirmFormStrategy) {
      this.formSaveStrategy.confirmSaveDeliveryAddress();
    }
    this.onClose();
  }
}
